import React from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'

import { IconButton, Tooltip } from '@mui/material'
import ContentCopyIcon from '@mui/icons-material/ContentCopy'

import T from 'T'
import { get } from 'utils/lodash'
import { isString } from 'utils/string'

const splitFullName = fullName => {
  if (!fullName || !isString(fullName)) {
    return { firstName: '', lastName: '' }
  }

  const nameParts = fullName.split(/\s+/)
  const firstName = get(nameParts, '0', '')
  const lastName = get(nameParts, 'length', 0) > 1 ? nameParts.slice(1).join(' ') : ''

  return { firstName, lastName }
}

const FillName = ({ customerName = '', onClick = noop }) => {
  const trimmedCustomerName = customerName?.trim()

  const handleClick = () => {
    const { firstName, lastName } = splitFullName(trimmedCustomerName)
    onClick(firstName, lastName)
  }

  return (
    <Tooltip title={T.COPY_CUSTOMER_NAME_TO_CONTACT_NAME}>
      <span>
        <IconButton aria-label={T.COPY_CUSTOMER_NAME_TO_CONTACT_NAME} onClick={handleClick} disabled={!trimmedCustomerName}>
          <ContentCopyIcon />
        </IconButton>
      </span>
    </Tooltip>
  )
}

FillName.propTypes = {
  customerName: PropTypes.string,
  onClick: PropTypes.func,
}

export default FillName
